var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grad-reqs-check",class:_vm.gradReqsClass,on:{"click":function($event){return _vm.$emit( 'click', _vm.reqsRemaining )}}},[_c('p',{staticClass:"grad-reqs-check-text"},[_vm._v(_vm._s(_vm.displayedText))]),_c('chevIcon',{staticClass:"icon-chevRight"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }